import styled from 'styled-components';
import { Text14Light } from '../../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  padding: 2.4rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.2rem;
`;

export const NavigationContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const NavigationItem = styled.div`
  a {
    padding: 1rem 1.4rem;
    border-radius: 12px;
    border: 1px solid #eef2f6;
    background: #fff;
    box-shadow:
      4px 5px 2px 0 rgba(0, 0, 0, 0),
      2px 3px 2px 0 rgba(0, 0, 0, 0.01);
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a.active {
    background: #badaf7;
    border-color: #badaf7;
    box-shadow: none;
  }
`;

export const NavLinkText = styled(Text14Light)`
  letter-spacing: -0.14px;
`;

export const Content = styled.div`
  margin-top: 1.6rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const FiltersCard = styled.div`
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 1.6rem;
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.6rem;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media only screen and (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.6rem;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FullWidthItem = styled.div`
  grid-column: 1 / -1;
`;

export const StatsRow = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.6rem;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media only screen and (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
